<template>
  <div class="main-wrapper" :class="!minibar ? '' : 'mini-sidebar'">
  	 <Header />
    <Sidebar />
    <div class="page-wrapper">
      <div class="container-fluid">


    	   <router-view />
      </div> 

      <div id="widget-chat">
        <a href="https://chat.whatsapp.com/JYSrgAGKFbrB9X52ul2VEi" target="_blank">
            <img src="../assets/images/wa.png"  border="0" width="32" height="32"  /> Butuh Bantuan? Klik Disini 
        </a>

    </div>  
	</div>   
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";  
import Header from "../components/Dashboard/Topbar";
import Sidebar from "../components/Dashboard/Sidebar";	
export default {
  computed: {
    ...mapState({
       minibar: state => state.minibar
    })
  },
	components: {
   		Header,
    	Sidebar
  	},
	 name: "dashboard",
};
</script>

<style>
      #widget-chat {
        width: 200px;
        background: green;
        color: white;
        height: 40px;
        bottom: 0;
        right: 20px;
        position: fixed;
        padding: 5px 10px;
        font-size: 10px;
        font-weight: 600;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
    }
    #widget-chat a{
         color: white;
    }
</style>



// WEBPACK FOOTER //
// src/layout/Dashboard.vue